import React from 'react';
import './BottomNav.css';

const BottomNav = ({ currentPage, onPageChange }) => {
  const tabs = [
    { id: 'calculate', label: 'Calculate', icon: '\u{1F9EE}' },
    { id: 'tenants', label: 'Tenants', icon: '\u{1F465}' },
    { id: 'history', label: 'History', icon: '\u{1F4CA}' },
    { id: 'settings', label: 'Settings', icon: '\u2699\uFE0F' }
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`bottom-nav-tab ${currentPage === tab.id ? 'active' : ''}`}
          onClick={() => onPageChange(tab.id)}
        >
          <span className="bottom-nav-icon">{tab.icon}</span>
          <span className="bottom-nav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
